//
// Format Mobile Number
// --------------------------------------------------

export class FormatPhoneInput {
    // Format mobile number into the format: +61 4xx yyy zzz
    static formatMobileNumber(mobileNumber) {
        const formattedNumber = mobileNumber.replace(/\s/g, '');

        if (formattedNumber) {
            const matches = formattedNumber.match(/^\+?(61)?0?4(\d{2})(\d{3})(\d{3})$/);
            if (matches) {
                mobileNumber = `+61 4${matches[2]} ${matches[3]} ${matches[4]}`;
            }
        }

        return mobileNumber;
    }

    // Format landline number into the format: +61 0X YYYY ZZZZ
    static formatLandlineNumber(landlineNumber) {
        const formattedNumber = landlineNumber.replace(/\s/g, '');

        if (formattedNumber) {
            const matches = formattedNumber.match(/^\+?(61)?0?(\d)(\d{4})(\d{4})$/);
            if (matches) {
                landlineNumber = `+61 ${matches[2]} ${matches[3]} ${matches[4]}`;
            }
        }

        return landlineNumber;
    }
}